/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Remind_Digest_PlanInputs */

const en_portal_remind_digest_plan = /** @type {(inputs: Portal_Remind_Digest_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan: Day A · legs`)
};

const pl_portal_remind_digest_plan = /** @type {(inputs: Portal_Remind_Digest_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan: Dzień A · nogi`)
};

/**
* | output |
* | --- |
* | "Plan: Day A · legs" |
*
* @param {Portal_Remind_Digest_PlanInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_remind_digest_plan = /** @type {((inputs?: Portal_Remind_Digest_PlanInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Remind_Digest_PlanInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_remind_digest_plan(inputs)
	return en_portal_remind_digest_plan(inputs)
});